import React from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Alert,
  Progress,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

const TranscriptProgressBar = ({ steps, currentStep }) => {
  const completedStepsCount = currentStep.length;

  const getColor = (index) => {
    // Generate different shades of #540000 based on the step index
    const baseShade = 0x54; // Base red value for #540000 in hexadecimal
    const stepShade = baseShade - (index / (steps.length - 1)) * baseShade;
    return `rgb(${stepShade}, 0, 0)`; // Red with varying shades, green and blue are 0
  };

  return (
    <div className="container mt-4 mb-4">
      <Progress multi style={{ height: "30px" }}>
        {steps.map((label, index) => {
          const isCompleted = index < completedStepsCount;

          return (
            <Progress
              key={index}
              bar
              animated
              color="danger"
              value={isCompleted ? 100 / steps.length : 0}
              style={{
                width: isCompleted ? `${100 / steps.length}%` : "0%",
                backgroundColor: isCompleted ? getColor(index) : "#d3d3d3", // Apply different shades of #540000
                transition: "width 0.6s ease, background-color 0.6s ease",
              }}
            />
          );
        })}
      </Progress>
      <div
        className="d-flex justify-content-between mt-2"
        style={{ fontSize: "0.8rem" }}
      >
        {steps.map((label, index) => (
          <span
            key={index}
            style={{
              color: index < completedStepsCount ? getColor(index) : "#d3d3d3",
            }}
          >
            {label}
          </span>
        ))}
      </div>
    </div>
  );
};

export default TranscriptProgressBar;
